<template>
  <div v-if="!field || !field.length">
    <div class="p-5">
      Please select a report tab, friend
    </div>
  </div>
  <div v-else>
    <div v-if="loading || !reportsBlank">
      <b-card v-if="false" no-body bg-variant="light" class="border-0 m-4 p-2 d-inline-block">
        <b-form-checkbox-group v-model="enabledStats" :options="statCheckboxOptions">
        </b-form-checkbox-group>
      </b-card>
      <report-time-stat-graphs v-if="field !== 'date'"
        @color-update="colorUpdate($event)"
        :report="reports.graph.results"
        :stats="options.stats"
        :fields="fields"
        :interval="options.interval"
        :joint-tooltip="true"
        :currently-viewed-report="currentlyViewedReport"
        :timezone="options.timezone">
      </report-time-stat-graphs>
      <report-time-graph v-if="field === 'date'"
                               @color-update="colorUpdate($event)"
                               :report="reports.graph.results"
                               :stats="options.stats"
                               :fields="fields"
                               :interval="options.interval"
                               :currently-viewed-report="currentlyViewedReport"
                               :timezone="options.timezone">
      </report-time-graph>
      <report-table
        @page-change="pageChange($event)"
        :report="reports.table.results"
        :stats="options.stats"
        :interval="options.interval"
        :fields="fields"
        :graph-colors="graphColors"
        :current-page="currentPage"
        :per-page="perPage"
        :synced-with-graph="true"
        ref="table">
      </report-table>
      <hr class="m-0 border-border"/>
      <b-pagination
        v-if="perPage > 0 && reports.table.results.length > 0"
        class="mt-3"
        :total-rows="reports.table.results.length"
        align="center"
        v-model="currentPage"
        :per-page="perPage">
      </b-pagination>
    </div>
    <no-results v-else></no-results>
  </div>
</template>

<script>
    import ReportTimeStatGraphs from '@/reports/components/graphs/ReportTimeStatGraphs'
    import ReportTimeGraph from "./graphs/ReportTimeGraph";
    import ReportTable from '@/reports/components/ReportTable'
    import {ReportsApi} from '@/reports/api'
    import NoResults from '@/components/NoResults'

    export default {
        props: {
            options: {type: Object, required: true},
            field: {type: String, required: true}
        },
        data() {
            return {
                graphColors: {},
                currentlyViewedReport: [],
                currentPage: 1,
                perPage: 10,
                loading: true,
                reports: {
                    table: {
                        results: []
                    },
                    graph: {
                        results: []
                    }
                }
            }
        },
        methods: {
            processedOptions () {
                let po = JSON.parse(JSON.stringify(this.options))
                if(this.field === 'pub_name') {
                    let f = po.filters
                    if(!f) {
                        f = []
                        po.filters = f
                    }

                    console.log("Restricting pub query to smartrtb pubs")
                    f.push({ field: 'exchange_id', operator: 'EQUAL', value: 'smartrtb' })

                    return po
                }

                return po
            },
            pageChange(currentlyViewedReport) {
                this.currentlyViewedReport = currentlyViewedReport
            },
            colorUpdate(colors) {
                this.graphColors = colors
            },
            getReports() {
                Promise.all([this.getTableReport(), this.getGraphReport()]).then(() => {
                    this.loading = false
                })
            },
            getTableReport(tab) {
                return ReportsApi.bqreport(this.tableQuery, this).then((data) => {
                    this.reports.table.results = data.results
                }, (e) => {
                    console.error(e)
                })
            },
            getGraphReport(tab) {
                return ReportsApi.bqreport(this.graphQuery, this).then((data) => {
                    this.reports.graph.results = data.results
                }, (e) => {
                    console.error(e)
                })
            },
        },
        computed: {
            fields() {
                return this.field ? [this.field] : []
            },
            reportsBlank() {
                return this.reports.table.results.length === 0 || this.reports.graph.results.length === 0
            },
            graphQuery() {
                let query = JSON.parse(JSON.stringify(this.processedOptions()))
                if(this.field !== 'date') {
                    query.fields = [this.field]
                } else {
                    query.fields = []
                    query.sortField = "date"
                    query.sort = "ASC"
                }

                return query
            },
            tableQuery() {
                let query = JSON.parse(JSON.stringify(this.processedOptions()))

                if(this.field !== 'date') {
                    query.interval = null
                    query.fields = [this.field]
                } else {
                    query.fields = []
                    query.sortField = "date"
                    query.sort = "ASC"
                }

                return query
            }
        },
        watch: {
            'options': {
                handler: function () { this.getReports() },
                deep: true
            }
        },
        mounted() {
            if (this.field && this.field.length > 0)
              this.getReports()
        },
        components: {
            NoResults,
            ReportTimeStatGraphs,
            ReportTable,
            ReportTimeGraph
        }
    }
</script>



// WEBPACK FOOTER //
// src/reports/components/MultiStatFieldView.vue